dataIdFromObject